module.exports = __webpack_public_path__ + "img/banner_2.065acb6f.jpg";